/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V3StackAdaptTimeSlot } from '../models/V3StackAdaptTimeSlot';
import { HttpFile } from '../http/http';

/**
* Setting for time and budget on a day
*/
export class V3StackAdaptDayOption {
    /**
    * Time slots for the day
    */
    'timeSlots'?: Array<V3StackAdaptTimeSlot>;
    /**
    * Daily budget for the day
    */
    'dailyBudget'?: number;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "timeSlots",
            "baseName": "timeSlots",
            "type": "Array<V3StackAdaptTimeSlot>",
            "format": ""
        },
        {
            "name": "dailyBudget",
            "baseName": "dailyBudget",
            "type": "number",
            "format": "float"
        }    ];

    static getAttributeTypeMap() {
        return V3StackAdaptDayOption.attributeTypeMap;
    }

    public constructor() {
    }
}

